import React, {useCallback} from "react";
import "./index.scss";
import {ModalPortal} from "features/components/modal";
import {Icon} from "features/components/icon";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";
import {connect} from "react-redux";
import {
    deleteAccountErrorSelector,
    deleteAccountLoadingSelector,
    deleteAccountSuccessSelector
} from "features/modals/delete-account/selectors";
import {deleteAccountSetShow, deleteAccountStart} from "features/modals/delete-account/reducer";

/* istanbul ignore next */
const mapStateToProps = state => ({
    error: deleteAccountErrorSelector(state),
    loading: deleteAccountLoadingSelector(state),
    success: deleteAccountSuccessSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    deleteAccountStart,
    deleteAccountSetShow
};

export const DeleteAccountModal = (props) => {
    const {error, loading, success} = props;
    const {deleteAccountSetShow, deleteAccountStart} = props;
    const doRequestDelete = useCallback(() => {
        deleteAccountStart();
    }, [deleteAccountStart]);

    const doCancel = useCallback(() => {
        deleteAccountSetShow(false);
    }, [deleteAccountSetShow]);

    return <ModalPortal size={"small"} className={"delete-account-modal"}>
        <Icon>alert</Icon>
        <Title size={24} align={"center"}>{__("modal.delete-account.title")}</Title>
        <Text size={16} align={"center"}>{__("modal.delete-account.text")}</Text>
        {error.inError && <Text size={16} align={"center"} color={"danger"}>{__(error.error)}</Text>}
        {success && <Text size={16} align={"center"} color={"success"}>{__("modal.delete-account.success")}</Text>}
        <Button title={__("buttons.send-delete-request")} onClick={doRequestDelete} status={loading ? "loading" : "danger"} icon={"arrow-right"} />
        <Button title={__("buttons.cancel")} onClick={doCancel} type={"outlined"} size={"small"} />
    </ModalPortal>
}
export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccountModal);